const regions = [
    {
        code: 'LOCAL',
        domainPrefix: 'app-dev.',
        regionCode: 1
    },
    {
        code: 'IONOS_FRANKFURT',
        domainPrefix: '',
        regionCode: 1
    },
    {
        code: 'AZ_EU_WEST',
        domainPrefix: 'app.',
        regionCode: 1
    },
    {
        code: 'IONOS_FRANKFURT_staging',
        domainPrefix: 'staging.',
        regionCode: 1
    },
    {
        code: 'AZ_EU_WEST_staging',
        domainPrefix: 'app-staging.',
        regionCode: 1
    },
    {
        code: 'EU1',
        domainPrefix: 'app.eu1.',
        regionCode: 4
    },
    {
        code: 'EU1_staging',
        domainPrefix: 'app.eu1-staging.',
        regionCode: 4
    }
]

export function changeRegionURL(newRegionCode, oldURL) {
    const newRegion = regions.find(r => r.code === newRegionCode)
    if (newRegion) {
        const urlToReplace = oldURL || location.href
        return urlToReplace.replace(location.origin, 'https://' + newRegion.domainPrefix + 'nuvolos.cloud')
    }
    return location.origin
}

export function getCurrentRegionCode() {
    const cr = regions.find(e => location.origin.match('https://' + e.domainPrefix + 'nuvolos.cloud'))
    return cr?.code
}

export function getCurrentRegionRegionCode() {
    const cr = regions.find(e => location.origin.match('https://' + e.domainPrefix + 'nuvolos.cloud'))
    return cr?.regionCode
}

export function isCurrentRegionEU1() {
    return getCurrentRegionCode() === 'EU1' || getCurrentRegionCode() === 'EU1_staging'
}

export function isSameRegion(regionCode) {
    if (!regionCode) return true
    const currentRegion = getCurrentRegionRegionCode()
    const targetRegion = regionCode

    if (!currentRegion || !targetRegion) return true
    return currentRegion === targetRegion
}
